import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Search, MapPin, Mail } from 'lucide-react';

const Header = () => {
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Furniture', path: '/furniture' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact-us' },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-black">
      <div className="max-w-[1440px] mx-auto px-3 sm:px-6 md:px-10 py-4 md:py-5 flex items-center justify-between gap-2 sm:gap-3">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <span className="font-serif-logo text-white text-[12px] sm:text-base md:text-2xl tracking-[0.08em] sm:tracking-[0.12em] md:tracking-[0.18em] whitespace-nowrap">
            SATIS FURNITURE
          </span>
        </Link>

        {/* Nav — always visible */}
        <nav className="flex items-center gap-3 sm:gap-5 md:gap-8 lg:gap-10 flex-shrink-0">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`font-display text-[12px] sm:text-sm md:text-base text-white hover:text-white/80 transition-colors duration-300 whitespace-nowrap ${
                isActive(item.path) ? 'underline underline-offset-[6px] decoration-1' : ''
              }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        {/* Right icons — hidden on small screens */}
        <div className="hidden md:flex items-center gap-5 flex-shrink-0">
          <button aria-label="Search" className="text-white hover:text-white/70 transition-colors">
            <Search className="w-5 h-5" strokeWidth={1.5} />
          </button>
          <a
            href="https://maps.google.com/?q=12+Perry+St+Campsie+NSW+2194"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Location"
            className="text-white hover:text-white/70 transition-colors"
          >
            <MapPin className="w-5 h-5" strokeWidth={1.5} />
          </a>
          <a
            href="mailto:wangjianjohn@hotmail.com"
            aria-label="Email"
            className="text-white hover:text-white/70 transition-colors"
          >
            <Mail className="w-5 h-5" strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
